import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { endpoints } from '@/API/endpoints';
import { createParams } from '@/helpers/createParams';
import { monday, sunday } from '@/helpers/currentWeek';
import { useApi } from '@/hooks/useApi/useApi';

import { TPageInfo } from '../dto';
import Filters from './filters/Filters';
import Main from './main/Main';
import classes from './PlanningManager.module.scss';
import Supervisor from './supervisor/Supervisor';

const PlanningManager = () => {
	const [isSupervisorEditUserEmployment, setIsSupervisorEditUserEmployment] = useState(false);
	const [pageInfo, setPageInfo] = useState<TPageInfo | null>(null);
	const [searchParams] = useSearchParams();

	const { apiGet } = useApi();

	useEffect(() => {
		const fetchData = async () => {
			const pageInfoParams = createParams(searchParams, {
				date_start: searchParams.get('date_start') || monday,
				date_end: searchParams.get('date_end') || sunday,
			});

			const pageInfoRes = await apiGet(endpoints.planningTotal, pageInfoParams);
			setPageInfo(pageInfoRes.data);
		};

		fetchData();
	}, []);

	return (
		<div className={classes.container}>
			<Filters
				isSupervisorEditUserEmployment={isSupervisorEditUserEmployment}
				setIsSupervisorEditUserEmployment={setIsSupervisorEditUserEmployment}
			/>
			{isSupervisorEditUserEmployment ? (
				<Supervisor pageInfo={pageInfo} />
			) : (
				<Main pageInfo={pageInfo} />
			)}
		</div>
	);
};

export default PlanningManager;
